module.exports = __webpack_public_path__ + "img/74.2fcbe2a.jpg";